import React, { useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { scroller } from "react-scroll";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();



  const handleNavigation = (section) => {

    if (location.pathname !== "/") {

      navigate("/");

      setTimeout(() => {
        scroller.scrollTo(section, {
          smooth: true,
          duration: 500,
          offset: -100,
        });
      }, 100);

    } else {

      scroller.scrollTo(section, {
        smooth: true,
        duration: 500,
        offset: -100,
      });

    }

    closeMenu();
  };

  const currentPath = location.pathname.split("/").pop();

  const openMenu = () => {
    setMenuOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeMenu = () => {
    setMenuOpen(false);
    document.body.style.overflow = "";
  };

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") closeMenu();
    };

    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);

  const isActive = (path) => {
    if ((currentPath === "" || currentPath === "index") && path === "index")
      return true;
    return currentPath === path;
  };

  return (
    <>
      {/* <div
        className={`ax-offcanvas-backdrop ${menuOpen ? "ax-open" : ""}`}
        onClick={closeMenu}
      ></div> */}

      <header className="ax-header-nav">
        <div className="ax-header-inner">

          <Link to="/" className="ax-header-logo">
            <div className="ax-logo-icon">
              <img src="/assets/images/axeselllogo.webp" alt="axesell" />
            </div>
          </Link>

          <ul className="ax-header-links">
            <li>
              <button
                className="  btn ax-nav-link"
                onClick={() => handleNavigation("solution")}
              >
                Solution
              </button>
            </li>
            <li>

              <button
                className="  btn ax-nav-link"
                onClick={() => handleNavigation("feature")}
              >
                Features
              </button>
            </li>
            <li>
              {/* <ScrollLink
                to="pricing"
                smooth={true}
                duration={500}
                offset={-100}
                className="ax-nav-link"
              >
                Pricing
              </ScrollLink> */}
              {/* <button
                className="  btn ax-nav-link"
                onClick={() => handleNavigation("pricing")}
              >
               Pricing
              </button> */}

              <Link to="/blog" className="  btn ax-nav-link">Blog</Link>
            </li>
            <li>
              <button
                className="  btn ax-nav-link"
                onClick={() => handleNavigation("about")}
              >
                About Us
              </button>
            </li>

            {/* <li>
               <
               
                to="/blogdetail"
               
              >
             blogdetail
              </Link>
            </li> */}
          </ul>

          {/* CTA */}
          <div className="ax-header-cta">
            <Link to="/contact" className="ax-cta-btn">
              Contact Us
            </Link>
          </div>

          {/* Hamburger */}
          <button
            className="ax-hamburger-btn"
            onClick={openMenu}
          >
            <span className="ax-bar"></span>
            <span className="ax-bar"></span>
            <span className="ax-bar"></span>
          </button>
        </div>
      </header>

      {/* Offcanvas */}
      <nav
        className={`ax-offcanvas ${menuOpen ? "ax-open" : ""}`}
        aria-hidden={!menuOpen}
      >
        <div className="ax-offcanvas-header">
          <Link to="/" className="ax-logo-icon" tabIndex={menuOpen ? 0 : -1}>
            <img src="/assets/images/axeselllogo.webp" alt="axesell" />
          </Link>

          <button className="ax-offcanvas-close" onClick={closeMenu} tabIndex={menuOpen ? 0 : -1}>
            ✕
          </button>
        </div>

        <ul className="ax-offcanvas-links">
          {/* {["solution", "feature", "blog", "about"].map((item) => (
            <li key={item}>
              <ScrollLink
                to={item}
                smooth={true}
                duration={500}
                offset={-100}
                spy={true}
                tabIndex={menuOpen ? 0 : -1}
                className={`ax-oc-link ${isActive(item) ? "ax-active" : ""}`}
                onClick={closeMenu}
                
              >
                {item === "feature"
                  ? "Our Features"
                  : item.charAt(0).toUpperCase() + item.slice(1)}
              </ScrollLink>
            </li>
          ))} */}



          {["solution", "feature", "blog", "about"].map((item) => (
            <li key={item}>

              {item === "blog" ? (

                <Link
                  to="/blog"
                  className="ax-oc-link"
                  onClick={closeMenu}
                  tabIndex={menuOpen ? 0 : -1}
                >
                  Blog
                </Link>

              ) : (

                <ScrollLink
                  to={item}
                  smooth={true}
                  duration={500}
                  offset={-100}
                  spy={true}
                  tabIndex={menuOpen ? 0 : -1}
                  className={`ax-oc-link ${isActive(item) ? "ax-active" : ""}`}
                  onClick={closeMenu}
                >
                  {item === "feature"
                    ? "Our Features"
                    : item.charAt(0).toUpperCase() + item.slice(1)}
                </ScrollLink>

              )}

            </li>
          ))}
        </ul>

        <div className="ax-offcanvas-footer">
          <Link to="/contact" className="ax-cta-btn" tabIndex={menuOpen ? 0 : -1}>
            Contact Us
          </Link>
        </div>
      </nav>
    </>
  );
};

export default Header;